// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"75b45ecb","845":"237556c0"}[chunkId] + ".chunk.js";
};